module.exports = __webpack_public_path__ + "static/img/9.f6dd306.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/q_and_a/9.png
// module id = neVR
// module chunks = 0